import DriverPlanEntryCheckoutEventAddRequest, {
  DriverPlanEntryCheckoutEventAddRequestBody,
} from "./driver-plan-entry-checkout-event-add.request";

const createBody = (
  request: DriverPlanEntryCheckoutEventAddRequest,
): DriverPlanEntryCheckoutEventAddRequestBody => {
  return {
    achievedAt: request.achievedAt,
    haltingTime: request.haltingTime,
    highwayCharge: request.highwayCharge,
    nodeId: request.nodeId,
  };
};

const driverPlanEntryCheckoutEventAddRequestFactory = {
  createBody,
};

export default driverPlanEntryCheckoutEventAddRequestFactory;
